//
import endpoints from '../endpoints';
import WebMethodService from '../WebMethodService';

class PreferenceCenterAPI {

  /**
   * Restituisce email del subscriber a partire da idOptIn e hash
   * @param {number} idOptIn 
   * @param {string} hash 
   * @returns {Promise}
   */
  static getSubscriberEmail(idOptIn, hash) {
    const params = {
      idOptIn: idOptIn,
      hash: hash
    };

    return WebMethodService.callWebMethod(endpoints.preferencecenter.getSubscriberEmail, params);
  }

  /**
   * 
   * @param {number} idOptIn 
   * @param {string} hash 
   * @param {number} idList 
   * @returns {Promise}
   */
  static loadPrefCenterOptions(idOptIn, hash, idList) {
    const params = {
      idOptIn: idOptIn,
      hash: hash,
      idList: idList
    };

    return WebMethodService.callWebMethod(endpoints.preferencecenter.loadPrefCenterOptions, params);
  }
  

  /**
   * 
   * @param {number} idOptIn 
   * @param {string} hash 
   * @param {number} idList 
   * @returns {Promise}
   */
  static loadSubscriberPreferences(idOptIn, hash, idList) {
    const params = {
      idOptIn: idOptIn,
      hash: hash,
      idList: idList
    };

    return WebMethodService.callWebMethod(endpoints.preferencecenter.loadSubscriberPreferences, params);
  }

  static exportAnagrData(idOptIn, hash, idList){
    const path = endpoints.exportService.exportAnagrData;
    window.location.href = path + '?hash=' + hash + '&idOptIn=' + idOptIn + '&idList=' + idList;
  }

  
  /**
   * 
   * @param {number} idOptIn
   * @param {string} hash 
   * @param {number} idList 
   * @param {number} idNL 
   * @param {array} subscription
   * @param {array} tracking
   * @returns {Promise}
   */
  static saveSubscriberPreferences(idOptIn, hash, idList, idNL, subscription, tracking)  {
    const params = {
      idOptIn: idOptIn,
      hash: hash,
      idList: idList,
      idNL: idNL,
      subscription: subscription,
      tracking: tracking
    };

    return WebMethodService.callWebMethod(endpoints.preferencecenter.saveSubscriberPreferences, params);
  }

  /**
   * Restituisce messaggi di default per eliminazione lista
   * @param {number} idOptIn 
   * @param {string} hash 
   * @returns {Promise}
   */
  static getDefaultListValues(idOptIn, hash) {
    const params = {
      idOptIn: idOptIn,
      hash: hash
    };
    return WebMethodService.callWebMethod(endpoints.preferencecenter.getDefaultListValues, params);
  }


  
  /**
   * Restituisce messaggi di default per eliminazione lista
   * @param {number} idOptIn 
   * @param {string} hash 
   * @param {number} idList 
   * @param {number} idForm 
   * @returns {Promise}
   */
  static getAutoprofileFormAvailability(idOptIn, hash, idList, idForm) {
    const params = {
      idOptIn: idOptIn,
      hash: hash,
      idList: idList,
      idForm: idForm
    };
    return WebMethodService.callWebMethod(endpoints.preferencecenter.getAutoprofileFormAvailability, params);
  }

}

export default PreferenceCenterAPI;